import React, { useState, useEffect } from 'react';
import { generationsAPI } from '../../services/api';
import { getImageModelLabel } from '../../services/imageModels';
import ClipboardIcon from '../ClipboardIcon';
import Timer from '../Timer/Timer';
import './FailedGenerations.css';

const FailedGenerations = () => {
  const [failedGenerations, setFailedGenerations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFailedGenerations();
  }, []);

  const loadFailedGenerations = async () => {
    try {
      const response = await generationsAPI.getFailed();
      setFailedGenerations(response.data);
    } catch (error) {
      console.error('Failed to load failed generations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this failed generation?')) return;

    try {
      await generationsAPI.delete(id);
      loadFailedGenerations();
    } catch (error) {
      console.error('Failed to delete generation:', error);
    }
  };

  const handleCopyPrompt = async (prompt) => {
    if (!prompt) return;
    try {
      await navigator.clipboard.writeText(prompt);
    } catch (error) {
      console.error('Failed to copy prompt:', error);
    }
  };

  return (
    <div className="failed-generations-container">
      <h1>Failed Generations</h1>

      {loading ? (
        <p>Loading...</p>
      ) : failedGenerations.length === 0 ? (
        <p className="empty-message">
          No failed generations. All your generations have been successful!
        </p>
      ) : (
        <div className="failed-generations-grid">
          {failedGenerations.map((gen) => (
            <div key={gen.id} className="failed-generation-card">
              <div className="failed-generation-icon">
                <span className="error-icon">⚠</span>
                <span className="failed-label">Failed</span>
              </div>
              <div className="failed-generation-info">
                <div className="generation-prompt-row">
                  <p className="generation-prompt">{gen.prompt}</p>
                  <button
                    type="button"
                    className="btn-copy-prompt"
                    onClick={() => handleCopyPrompt(gen.prompt)}
                    title="Copy prompt"
                    aria-label="Copy prompt"
                  >
                    <ClipboardIcon />
                  </button>
                </div>
                <div className="generation-meta">
                  {gen.model && <span>Modèle: {getImageModelLabel(gen.model)}</span>}
                  <span>{gen.aspect_ratio}</span>
                  <span>{gen.resolution}</span>
                  <span>{gen.output_format.toUpperCase()}</span>
                </div>
                {gen.error_message && (
                  <div className="error-details">
                    <strong>Error:</strong> {gen.error_message}
                  </div>
                )}
                <p className="generation-cost">Cost: €{parseFloat(gen.cost || 0).toFixed(2)}</p>
                {gen.generation_time_ms && (
                  <p className="generation-time">
                    Attempted for: <Timer startTime={0} endTime={gen.generation_time_ms} className="completed" />
                  </p>
                )}
                {gen.project_name && (
                  <p className="generation-project">
                    Project: {gen.project_name}
                  </p>
                )}
                <p className="generation-date">
                  {new Date(gen.created_at).toLocaleString()}
                </p>
                <button
                  onClick={() => handleDelete(gen.id)}
                  className="btn-delete-gen"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FailedGenerations;
